export default __webpack_public_path__ + "static/media/skill7.8f6e80f1.svg";